interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
}: SectionHeadingProps) {
  return (
    <div
      className={`reveal max-w-3xl ${
        align === "center" ? "mx-auto text-center" : "text-left"
      }`}
    >
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
          <i className="ri-sparkling-2-line text-sm" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-snug text-foreground-950">
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm md:text-base leading-relaxed text-foreground-600 ${
            align === "center" ? "mx-auto" : ""
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}